import { render, staticRenderFns } from "./WidgetUpcomingBookings.vue?vue&type=template&id=32de928c"
import script from "./WidgetUpcomingBookings.vue?vue&type=script&lang=js"
export * from "./WidgetUpcomingBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports